import {client as http} from "@/http_client";

export default {
    state: {
        tickets: [],
        currentTicket: null,
        loading: false
    },
    getters: {
        supportTickets: state => state.tickets,
        currentTicket: state => state.currentTicket,
        supportLoading: state => state.loading
    },
    mutations: {
        setSupportTickets(state, tickets) {
            state.tickets = tickets;
        },
        setCurrentTicket(state, ticket) {
            state.currentTicket = ticket;
        },
        setSupportLoading(state, loading) {
            state.loading = loading;
        }
    },
    actions: {
        loadTickets({commit}) {
            commit('setSupportLoading', true);
            return http.get('app/support/tickets', {force: true}).then(response => {
                commit('setSupportTickets', response.data);
            }).finally(() => {
                commit('setSupportLoading', false);
            });
        },
        loadTicket({commit}, id) {
            commit('setSupportLoading', true);
            return http.get(`app/support/tickets/${id}`, {force: true}).then(response => {
                commit('setCurrentTicket', response.data);
            }).finally(() => {
                commit('setSupportLoading', false);
            });
        },
        createTicket({dispatch}, data) {
            return http.post('app/support/tickets', data).then(response => {
                dispatch('loadTickets');
                return response.data;
            });
        },
        sendReply({dispatch}, {id, data}) {
            return http.post(`app/support/tickets/${id}/reply`, data).then(response => {
                dispatch('loadTicket', id);
                return response.data;
            });
        }
    }
};
